import React, { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import FinancePageHead from "../../components/FinancePageHead";
import TenantInvoicesTab from "../TenantInvoicesTab";
import { FINANCE_SECTIONS } from "../../utils/financeTerms";
import "../../assets/css/DigixLeads.css";
import "../../assets/css/FinanceManagement.css";

/** Finance > Invoices: bills Cloud Office sends to its clients, with Generate Monthly Invoice. */
function FinanceInvoicesPage() {
  const location = useLocation();
  const [params, setParams] = useSearchParams();
  const fromState = location.state?.filterClientId;
  const [clientId, setClientId] = useState(() =>
    fromState != null && fromState !== "" ? String(fromState) : params.get("client") || ""
  );

  useEffect(() => {
    if (fromState != null && fromState !== "") setClientId(String(fromState));
  }, [fromState, location.key]);

  const changeClient = (id) => {
    setClientId(id ? String(id) : "");
    setParams(id ? { client: String(id) } : {}, { replace: true });
  };

  return (
    <div className="digixleads-container finance-management-page">
      <FinancePageHead section={FINANCE_SECTIONS.invoices} />
      <div className="main-card">
        <div className="finance-management-tab-body">
          <TenantInvoicesTab scope="finance" filterClientId={clientId} onFilterClientIdChange={changeClient} />
        </div>
      </div>
    </div>
  );
}

export default FinanceInvoicesPage;
